import { inject, Injectable } from '@angular/core'
import { ArchivesService } from '@app/generated/api/archives/archives.service'
import type { ArchivesLandlordsListParams } from '@app/generated/api/model'

@Injectable({
  providedIn: 'root',
})
export class LandlordsApi {
  private readonly archivesService = inject(ArchivesService)

  list (params: ArchivesLandlordsListParams) {
    return this.archivesService.landlords(params)
  }
}
